import actionTypes from 'SRC/modules/redux/actionTypes'

export const setInfiniteScrollEnabled = infiniteScrollEnabled => ({
  type: actionTypes.SET_INFINITE_SCROLL_ENABLED,
  payload: infiniteScrollEnabled
})
